<template>
  <div style="margin: 0 15px;">
     <div class="nocast" v-if="!sel">
        <div v-if="cast_error == 'none'">
          There is currently no broadcast available for you to watch.
          Wait here until the host starts the broadcast.
        </div>
        <div v-if="cast_error == 'denied'">
          You are not allowed to watch the current broadcast.
        </div>
        <div v-if="cast_error == 'signin'">
          You must sign in to watch the current broadcast.
        </div>
        <div v-if="cast_error == 'unknown'">
          <span> An error occurred. </span>
          <span v-if="refresh_tid"> Retrying... </span>
        </div>
        <div v-if="refresh_tid && !cast_error">
          Requesting broadcast ...
        </div>
     </div>
     <arc-player
       :src="sel"
       :qna="qna"
       >
     </arc-player>

    <b-modal id="bv-qna-ok" size="sm"
       hide-header
       hide-footer>
       <b-row>
         <b-col style="font-size:0.9rem;">
           Continuing will bring you to the room and put you in line
           to ask a question. Other people will be able to see and
           hear you.
         </b-col>
       </b-row>
       <div style="padding: 1vw 0px">
         <b-button-group class="">
           <b-button size="sm"
             variant="primary"
             @click="qnaToRoom">
             Continue to the Room
           </b-button>
         </b-button-group>
         <b-button-group class="float-right">
           <b-button size="sm" @click="$bvModal.hide('bv-qna-ok')"
             variant="danger">
             Cancel
           </b-button>
         </b-button-group>
       </div>
    </b-modal>

    <b-modal id="bv-qna-full" size="sm"
       hide-header
       hide-footer>
       <b-row>
         <b-col style="font-size:0.9rem;">
           The limit has been reached on people lining up for questions.
           Try again later after a few people have finished.
         </b-col>
       </b-row>
       <div style="padding: 1vw 0px">
         <b-button-group class="float-right">
           <b-button size="sm" @click="$bvModal.hide('bv-qna-full')"
             variant="primary">
             Ok
           </b-button>
         </b-button-group>
       </div>
    </b-modal>

    <b-modal id="bv-qna-opened" size="sm"
       hide-header
       hide-footer>
       <b-row>
         <b-col style="font-size:0.9rem;">
           The host has opened up the room to questions. Click the hand
           next to the play button to become a participant and ask
           a question.
         </b-col>
       </b-row>
       <div style="padding: 1vw 0px">
         <b-button-group class="float-right">
           <b-button size="sm" @click="$bvModal.hide('bv-qna-opened')"
             variant="primary">
             Ok
           </b-button>
         </b-button-group>
       </div>
    </b-modal>

    <b-modal id="bv-askq" size="sm"
       hide-header
       hide-footer>
       <b-row>
         <b-col>
           <b-input placeholder="Name"
             v-model.trim="cast_question_dname"
             :disabled="!cast_question_init">
           </b-input>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
            <auto-text-area size="sm"  style="font-size:0.8rem"
              v-model.trim="cast_question"
              maxlength="150"
              placeholder="Your Question">
            </auto-text-area>
         </b-col>
       </b-row>
       <div style="padding: 1vw 0px">
         <div v-if="cast_question_error"
           style="font-size:0.7rem;color:red;">
           {{cast_question_error}}
         </div>
         <b-button-group>
           <b-button size="sm" @click="postQuestion"
             variant="primary">
             Post Question
           </b-button>
         </b-button-group>
         <b-button-group class="float-right">
           <b-button size="sm" @click="$bvModal.hide('bv-askq')"
             variant="outline-danger">
             Cancel
           </b-button>
         </b-button-group>
       </div>
    </b-modal>

  </div>
</template>

<script>
import vx_api from "../vuemix";
import { sync } from "vuex-pathify";
import store from "../store";
import ArcPlayer from "../components/ArcPlayer";
import AutoTextArea from "../components/AutoTextArea";

export default {
  name: "arc",
  components: {
    ArcPlayer,
    AutoTextArea,
  },
  created() {
    let vue = this;
  },
  data() {
    return {
      sel: null,
      qna: null,
      cast_error: "",
      refresh_tid: null,
      cast_cnt: 0,
      can_chat: false,
      cast_question_dname: "",
      cast_question: "",
      cast_question_init: true,
      cast_question_error: "",
    };
  },
  watch: {
    //$route(to, from) {
    //  this.refresh();
    //},
  },
  mounted() {
     let vue = this;
     if (vue.$parent.mydevice.set_background) {
        $("body").addClass("setbackground");
     }
     this.refresh();
  },
  beforeDestroy() {
    let vue = this;
    window.clearTimeout(vue.refresh_tid);
    window.wss_clr_routes(window.vx,"cast");
    vue.$parent.regCastAskCb();
  },
  methods: {
    refresh: function() {
      let vue = this;
      window.clearTimeout(vue.refresh_tid);
      vue.refresh_tid = null;
      window.wss_clr_routes(window.vx,"cast");
      window.vx_set_room(window.vx, vue.$router.currentRoute.params.acc, vue.$router.currentRoute.params.uid,"bcast");
      window.wss_open(vx, {
         acc: vx.room.acc,
         uid: (vx.user)? vx.user.id: "not set",
         routes_id: "cast",
         routes: {
           auth_me: function(){
             window.wss_send(vx, "auth_cast", {
                room: vx.room.name,
             });
           },
           opened: function() {
             /* Only handles no-auth case */
             if (vx.user) { return; }
             window.wss_send(vx, "auth_cast", {
                room: vx.room.name,
             });
             vue.recheckCast(20000);
           },
           auth_room: function(msg) {
           },
           room_ctrl: function(msg) {
             vue.can_chat = false;
             if (msg.data.error) {
               vue.qna = false;
               return;
             }
             if (!msg.data.join_is_pub) {
               vue.qna = false;
               return;
             }
             if (vue.qna === false) {
               vue.$bvModal.show('bv-qna-opened');
             }
             vue.qna = vue.qnaClick;
             if (msg.data.chat && msg.data.chat.mode != "disabled") {
               vue.can_chat = true;
             }
           },
           cast: function(msg) {
             vue.cast_cnt++;
             vue.$parent.regCastAskCb();
             if (msg.data.error) {
                vue.sel = null;
                if (["none","denied","signin"].includes(msg.data.error)) {
                   vue.cast_error = msg.data.error;
                } else {
                   vue.cast_error = "unknown";
                   vue.recheckCast(5000);
                }
                console.log(vue.cast_error);
                return;
             } else if (!msg.data.playurl) {
                vue.sel = null;
                return;
             } else if (vue.sel && vue.sel.handle &&
                        msg.data.handle == vue.sel.handle) {
                /* No change in source; Maybe change in attributes */
                vue.sel.done = msg.data.done;
                msg.data.can_ask && vue.$parent.regCastAskCb(vue.showAsk);
                return;
             }
             vue.sel = vue.toCF(msg.data);
             msg.data.can_ask && vue.$parent.regCastAskCb(vue.showAsk);
           },
         }
      });
    },
    recheckCast: function(base) {
      let vue = this;
      let tout = 5000;//(base*Math.random()) + base;
      console.log("refresh in",base,tout);
      window.clearTimeout(vue.refresh_tid);
      vue.refresh_tid = setTimeout(function() {
        vue.refresh_tid = null;
        console.log("refresh");
        window.wss_send(vx, "auth_cast", {
           room: vx.room.name,
        });
      },tout);
    },
    toCF: function(arc) {
      if (!arc) { return; }
      if (arc.playurl.indexOf("/vuemix-mmarc/") >= 0) {
        arc.url = arc.playurl.replace("/vuemix-mmarc/",
                                      "https://d1xyplvc108m9i.cloudfront.net/");
      } else if (arc.playurl.indexOf("/vuemix-devel/") >= 0) {
        arc.url = arc.playurl.replace("/vuemix-devel/",
                                      "https://s3.amazonaws.com/vuemix-devel/");
      }
      return arc;
    },
    qnaClick: function() {
      let vue = this;
      vue.$bvModal.show('bv-qna-ok');
    },
    showAsk: function() {
      let vue = this;
      vue.cast_question_error = "";
      vue.$bvModal.show('bv-askq');
    },
    postQuestion: function() {
      let vue = this;
      vue.cast_question_error = "";
      if (vue.cast_question_dname.length < 3) {
        vue.cast_question_error = "Please select a longer name";
        return;
      }
      if (vue.cast_question.length < 10) {
        vue.cast_question_error = "Please enter a longer question";
        return;
      }
      window.wss_send_cb(vx, "cast_post_msg", {
         dname: vue.cast_question_dname,
         msg: vue.cast_question,
      }, function(rsp) {
         //console.log("castq:",JSON.stringify(rsp));
         if (!rsp || !rsp.data || !rsp.data.ok) {
            vue.cast_question_error = "We were unable to post the question";
            return;
         }
         vue.$bvModal.hide('bv-askq');
         vue.cast_question = "";
         vue.cast_question_init = false;
      });
    },
    qnaToRoom: function() {
      let vue = this;
      vue.$bvModal.hide('bv-qna-ok');
      vue.$parent.refreshAVSources({
        cb: function() {
          if (vue.$parent.selected_audio_group[0] == 'Microphones' &&
              vue.$parent.selected_audio_source[0]) {
             if (vue.$parent.selected_video_group == 'Cameras' &&
                 vue.$parent.selected_video_source) {
                 vue.$parent.auto_start_capture = 'video';
             } else {
                 vue.$parent.auto_start_capture = 'audio';
                 vue.$parent.clearSelectedVideo();
             }
          }
          vue.$router.push({name: "room"});
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>

.nocast {
  margin: 1rem;
  text-align:center;
  color: white;
}

</style>
